import * as React from "react";

import PreviewThumbnail from "@/features/funnel/components/PreviewThumbnail";
import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";
import twMerge from "@replo/design-system/utils/twMerge";

type PageData = {
  route: string;
  title: string;
  description?: string;
};

export function PagePreviewCardSkeleton({
  hideDescription = false,
}: {
  hideDescription?: boolean;
}) {
  return (
    <div className="flex flex-col h-full">
      <div className="relative">
        <Skeleton className="w-full h-[250px] border-0.5 border-border rounded-xl" />
        <div className="absolute inset-0 rounded-xl pointer-events-none transition-colors duration-150 bg-white/50" />
      </div>
      <div className="flex flex-col gap-0.5 mt-3">
        <Skeleton className="h-5 w-2/3 rounded mb-1" />
        {!hideDescription && <Skeleton className="h-4 w-1/2 rounded" />}
      </div>
    </div>
  );
}

export default function PagePreviewCard({
  pageData,
  onClick,
  isSelected,
}: {
  pageData: PageData;
  onClick: () => void;
  isSelected?: boolean;
}) {
  return (
    <div className="flex flex-col h-full">
      <div className="relative" onClick={onClick}>
        <PreviewThumbnail
          pageRoute={pageData.route}
          className={twMerge(
            "w-full h-[250px] border-0.5 border-border rounded-xl cursor-pointer hover:bg-menu-item-hover",
            isSelected && "border-black border-2",
          )}
        />
        <div
          className={twMerge(
            "absolute inset-0 rounded-xl pointer-events-none transition-colors duration-150",
            isSelected ? "bg-black/10" : "bg-white/50",
          )}
        />
      </div>
      <div className="flex flex-col gap-0.5 mt-3">
        <h4 className="header-h4 line-clamp-1">{pageData.title}</h4>
        {pageData.description && (
          <p className="text-sm text-muted line-clamp-1">
            {pageData.description}
          </p>
        )}
      </div>
    </div>
  );
}
